import React, { Ref } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Flex from '@cobalt/react-flex';
import Label from '@cobalt/react-label';
import Input from '@cobalt/react-input';

import RadioGroup from './RadioGroup';

export interface RadioProps {
  id?: string;
  label?: string;
  checked?: boolean | string;
  disabled?: boolean;
  onChange?: (value: string) => void;
  forwardedRef?: Ref<HTMLInputElement>;
}

function Radio(props: RadioProps) {
  const { id = uuidv4(), label = '', checked = false, disabled = false, onChange, forwardedRef } = props;

  return (
    <Flex gap={2}>
      <Input
        forwardedRef={forwardedRef}
        id={id}
        type="radio"
        value={checked as string}
        checked={checked as boolean}
        disabled={disabled}
        onChange={() => onChange?.(checked as string)}
      />

      <Label style={{ fontWeight: 'normal' }} htmlFor={id}>
        {label}
      </Label>
    </Flex>
  );
}

Radio.Group = RadioGroup;

export default Radio;
